module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--8-0dbe2c8464d8486a814d7467f4a75398.jpg";